module.exports = __webpack_public_path__ + "img/tools_2.bda58e5b.png";